import { Tourney } from '@base/features/tournaments/model/interfaces';
import { t } from '@base/utils/helpers';
import Tabs, { TabPane } from '@ui-kit/components/tabs';
import React  from 'react';
import PendingTournamentParticipants from '../pendingTournamentParticipants/pendingTournamentParticipants';
import { PendingTournamentsCalculation } from '../pendingTournamentsCalculation/pendingTournamentsCalculation';
import styles from './pendingTournamentTabs.module.scss';

export default function PendingTournamentTabs(props: {tournament: Tourney}) {
  return (
    <Tabs style={{ height: '50%' }}>
      <TabPane label={t('participants')} key="1" className={styles.tab}>
        <PendingTournamentParticipants tournament={props.tournament}/>
      </TabPane>
      <TabPane label={t('calculate')} key="2" className={styles.tab}>
        <PendingTournamentsCalculation
          entryFee={props.tournament.EntryFee}
          extraBonus={props.tournament.ExtraBonus}
          pairing={props.tournament.PairingType}
        />
      </TabPane>
    </Tabs>
  );
};
